export default "__VITE_ASSET__5rpR0_$v__"